import { Injectable } from '@angular/core';
import { IM365AppDefinition } from '@office-start/app-host-types';

import { M356AppsConfigService } from './m365-apps-config.service';

@Injectable({
    providedIn: 'root'
})
export class M365PinnedAppService {

    public readonly accessTokens: Map<string, Promise<AccessTokenResponse>>;

    constructor(
        private readonly m356AppsConfigService: M356AppsConfigService
    ) {
        this.accessTokens = new Map<string, Promise<AccessTokenResponse>>();
    }

    public getPinnedApps(): ReadonlyArray<string> {
        return this.m356AppsConfigService.getPinnedApps();
    }

    public getPinnedAppDefinitions(): ReadonlyArray<IM365AppDefinition> {
        return this.m356AppsConfigService.getPinnedAppDefinitions();
    }

    public getPinnedAppManifest(appName: string): Promise<IM365AppDefinition> {
        return this.m356AppsConfigService.getAppManifest(appName);
    }

    public getPinnedAppManifestById(appId: string): Promise<IM365AppDefinition> {
        return this.m356AppsConfigService.getAppManifestById(appId);
    }
}
